import React, { useState, useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import PageNotFound from "./pages/PageNotFound";
import RefreshHandler from "./components/RefreshHandler";
import { checkSession } from "./services/authService";
import Login from "./pages/Login";
import ForgotPassowrd from "./pages/ForgotPassword";
import ResetPassowrd from "./pages/ResetPassword";
import Home from "./pages/Home/Index";

// User Route
import AddUser from "./pages/Users/AddUsers";
import UserList from "./pages/Users/Index";
import EditUser from "./pages/users/EditUser";
import UserProfile from "./pages/users/UserProfile";
// Department Route
import ListDepartment from "./pages/Department/Index";
import ViewDepartment from "./pages/Department/ViewDepartment";
// Carousel Route
import ListCarousel from "./pages/Carousel/Index";
import AddCarousel from "./pages/Carousel/Add-Carousel";
import EditCarousel from "./pages/Carousel/Edit-Carousel";

// Blogs Route
import BlogView from "./pages/Blog/BlogView";
import AddBlog from "./pages/Blog/Addblog";
import Blogdetails from "./pages/Blog/Blogdetails";
import Editblog from "./pages/Blog/Editblog";
import BlogApproval from "./pages/Blog/BlogApproval";

// File Manager

import FileManager from "./pages/FileManager/Index";

// Gallery View
import Gallery from "./pages/Gallery/Index";
import GalleryDetailsPage from "./pages/Gallery/GalleryView";

//Temp
import Temp from "./pages/Carousel/Temp";

//Event
import AddEvent from "./pages/Events/Add-Event";
import EditEvent from "./pages/Events/Edit-Event";
import ListEvent from "./pages/Events/Index";
import EventDetails from "./pages/Events/Event-Details";

// News

import ListNews from "./pages/News/Index";
import AddNews from "./pages/News/Add-News";
import EditNews from "./pages/News/Edit-News";
import NewsDetails from "./pages/News/News-Details";
import LogsListPage from "./pages/Logs/Index";


//activity
import ListActivity from "./pages/Activities/Index";
import ActivityDetails from "./pages/Activities/Activity-Details";
import AddActivity from "./pages/Activities/Add-Activity";
import EditActivity from "./pages/Activities/Edit-Activity";

//Notification
import ListPopup from "./pages/Notification/Popup";
import ListMarquee from "./pages/Notification/Marquee";



// Profile
import Profile from "./pages/profile/Index";
import EditProfile from "./pages/profile/EditProfile";



const AppRouter = () => {
  const [isAuth, setIsAuth] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const verifySession = async () => {
      const token = localStorage.getItem("token");
      if (token) {
        const isValid = await checkSession(token);
        setIsAuth(isValid);
        if (!isValid) {
          localStorage.removeItem("token");
        }
      }
      setLoading(false);
    };

    verifySession();
  }, []);

  if (loading) {
    return <div className="text-center mt-5">Loading...</div>;
  }

  return (
    <Router>
      <RefreshHandler setIsAuth={setIsAuth} />
      <Routes>
        <Route
          path="/"
          element={isAuth ? <Navigate to="/home" /> : <Navigate to="/login" />}
        />
        <Route path="/login" element={<Login setIsAuth={setIsAuth} />} />
        <Route
          path="/forgot-password"
          element={<ForgotPassowrd setIsAuth={setIsAuth} />}
        />
        <Route
          path="/reset-password/:token"
          element={<ResetPassowrd setIsAuth={setIsAuth} />}
        />
        <Route
          path="/home"
          element={
            isAuth ? <Home setIsAuth={setIsAuth} /> : <Navigate to="/login" />
          }
        />
        <Route
          path="/list-users"
          element={
            isAuth ? (
              <UserList setIsAuth={setIsAuth} />
            ) : (
              <Navigate to="/login" />
            )
          }
        />
        <Route
          path="/add-users"
          element={
            isAuth ? (
              <AddUser setIsAuth={setIsAuth} />
            ) : (
              <Navigate to="/login" />
            )
          }
        />
        <Route
          path="/edit-users/:id"
          element={
            isAuth ? (
              <EditUser setIsAuth={setIsAuth} />
            ) : (
              <Navigate to="/login" />
            )
          }
        />
        <Route
          path="/user-profile/:id"
          element={
            isAuth ? (
              <UserProfile setIsAuth={setIsAuth} />
            ) : (
              <Navigate to="/login" />
            )
          }
        />

        <Route
          path="/list-department"
          element={
            isAuth ? (
              <ListDepartment setIsAuth={setIsAuth} />
            ) : (
              <Navigate to="/login" />
            )
          }
        />
        <Route
          path="/view-department/:id"
          element={
            isAuth ? (
              <ViewDepartment setIsAuth={setIsAuth} />
            ) : (
              <Navigate to="/login" />
            )
          }
        />

        {/* Carousel Routing */}
        <Route
          path="/list-carousel"
          element={
            isAuth ? (
              <ListCarousel setIsAuth={setIsAuth} />
            ) : (
              <Navigate to="/login" />
            )
          }
        />
        <Route
          path="/add-carousel"
          element={
            isAuth ? (
              <AddCarousel setIsAuth={setIsAuth} />
            ) : (
              <Navigate to="/login" />
            )
          }
        />
        <Route
          path="/edit-carousel/:id"
          element={
            isAuth ? (
              <EditCarousel setIsAuth={setIsAuth} />
            ) : (
              <Navigate to="/login" />
            )
          }
        />

        {/* Blogs Routing */}
        <Route
          path="/blogs"
          element={
            isAuth ? (
              <BlogView setIsAuth={setIsAuth} />
            ) : (
              <Navigate to="/login" />
            )
          }
        />
        <Route
          path="/add-blog"
          element={
            isAuth ? (
              <AddBlog setIsAuth={setIsAuth} />
            ) : (
              <Navigate to="/login" />
            )
          }
        />
        <Route
          path="/blog-detail/:id"
          element={
            isAuth ? (
              <Blogdetails setIsAuth={setIsAuth} />
            ) : (
              <Navigate to="/login" />
            )
          }
        />
        <Route
          path="/edit-blog/:id"
          element={
            isAuth ? (
              <Editblog setIsAuth={setIsAuth} />
            ) : (
              <Navigate to="/login" />
            )
          }
        />

        <Route
          path="/blog-approval"
          element={
            isAuth ? (
              <BlogApproval setIsAuth={setIsAuth} />
            ) : (
              <Navigate to="/login" />
            )
          }
        />

        {/* Events Routing */}
        <Route
          path="/list-events"
          element={
            isAuth ? (
              <ListEvent setIsAuth={setIsAuth} />
            ) : (
              <Navigate to="/login" />
            )
          }
        />
        <Route
          path="/add-event"
          element={
            isAuth ? (
              <AddEvent setIsAuth={setIsAuth} />
            ) : (
              <Navigate to="/login" />
            )
          }
        />
        <Route
          path="/edit-event/:id"
          element={
            isAuth ? (
              <EditEvent setIsAuth={setIsAuth} />
            ) : (
              <Navigate to="/login" />
            )
          }
        />
        <Route
          path="/event-detail/:id"
          element={
            isAuth ? (
              <EventDetails setIsAuth={setIsAuth} />
            ) : (
              <Navigate to="/login" />
            )
          }
        />
        {/* News Routing */}

        <Route
          path="/list-news"
          element={
            isAuth ? (
              <ListNews setIsAuth={setIsAuth} />
            ) : (
              <Navigate to="/login" />
            )
          }
        />
        <Route
          path="/add-news"
          element={
            isAuth ? (
              <AddNews setIsAuth={setIsAuth} />
            ) : (
              <Navigate to="/login" />
            )
          }
        />
        <Route
          path="/edit-news/:id"
          element={
            isAuth ? (
              <EditNews setIsAuth={setIsAuth} />
            ) : (
              <Navigate to="/login" />
            )
          }
        />
        <Route
          path="/news-detail/:id"
          element={
            isAuth ? (
              <NewsDetails setIsAuth={setIsAuth} />
            ) : (
              <Navigate to="/login" />
            )
          }
        />

        {/* File Manager */}
        <Route
          path="/file-manager"
          element={
            isAuth ? (
              <FileManager setIsAuth={setIsAuth} />
            ) : (
              <Navigate to="/login" />
            )
          }
        />

        {/* Gallery  */}
        <Route
          path="/gallery"
          element={
            isAuth ? (
              <Gallery setIsAuth={setIsAuth} />
            ) : (
              <Navigate to="/login" />
            )
          }
        />

        <Route
          path="/gallery/:id"
          element={
            isAuth ? (
              <GalleryDetailsPage setIsAuth={setIsAuth} />
            ) : (
              <Navigate to="/login" />
            )
          }
        />

        {/* Logs */}

        <Route
          path="/logs"
          element={
            isAuth ? (
              <LogsListPage setIsAuth={setIsAuth} />
            ) : (
              <Navigate to="/login" />
            )
          }
        />

        {/* Temp */}

        <Route
          path="/temp-page"
          element={
            isAuth ? <Temp setIsAuth={setIsAuth} /> : <Navigate to="/login" />
          }
        />

        {/* Activity Routing */}

        <Route
          path="/list-activities"
          element={isAuth ? <ListActivity setIsAuth={setIsAuth} /> : <Navigate to="/login" />}
        />

        <Route
          path="/activity-detail/:id"
          element={isAuth ? <ActivityDetails setIsAuth={setIsAuth} /> : <Navigate to="/login" />}
        />

        <Route
          path="/add-activity"
          element={isAuth ? <AddActivity setIsAuth={setIsAuth} /> : <Navigate to="/login" />}
        />

        <Route
          path="/edit-activity/:id"
          element={isAuth ? <EditActivity setIsAuth={setIsAuth} /> : <Navigate to="/login" />}
        />

        <Route
          path="*"
          element={isAuth ? <PageNotFound /> : <Navigate to="/login" />}
        />

        
        {/* Profile */}
         <Route
          path="/profile"
          element={isAuth ? <Profile setIsAuth={setIsAuth} /> : <Navigate to="/login" />}
        />
        
        <Route
          path="/edit-profile"
          element={isAuth ? <EditProfile setIsAuth={setIsAuth} /> : <Navigate to="/login" />}
        />



        {/* Notification Routing */}
        <Route
          path="/notification/popup"
          element={
            isAuth ? <ListPopup setIsAuth={setIsAuth} /> : <Navigate to="/login" />
          }
        />

        <Route
          path="/notification/marquee"
          element={
            isAuth ? <ListMarquee setIsAuth={setIsAuth} /> : <Navigate to="/login" />
          }
        />


      </Routes>
    </Router>
  );
};

export default AppRouter;
